import { AbstractManager } from "./AbstractManager.js";
import { isDev, isArray, isDefined, getAncestorWhereUntil } from "../../utils/index.js";
const NORMALIZE_REF_NAME_REGEX = /\[\]$/;
function normalizeRefName(name) {
  return name.endsWith("[]") ? name.replace(NORMALIZE_REF_NAME_REGEX, "") : name;
}
function refBelongToInstance(ref, rootElement, name) {
  const isPrefixed = ref.dataset.ref.startsWith(name);
  const firstComponentAncestor = getAncestorWhereUntil(
    ref,
    (el) => el && (isPrefixed ? el.dataset.component === name && el : isDefined(el.dataset.component)) && el !== rootElement,
    (el) => el === rootElement
  );
  return firstComponentAncestor === rootElement;
}
function __register(that, refName) {
  const isMultiple = refName.endsWith("[]");
  const propName = normalizeRefName(refName);
  const { name } = that.__base.$options;
  const refs = Array.from(
    that.__element.querySelectorAll(
      `[data-ref="${refName}"],[data-ref="${name}.${refName}"]`
    )
  ).filter((ref) => refBelongToInstance(ref, that.__element, name));
  if (isDev && !isMultiple && refs.length > 1) {
    console.warn(
      `[${that.__base.$options.name}]`,
      `The "${refName}" ref has been found multiple times.`,
      "Did you forgot to add the `[]` suffix to its name?"
    );
  }
  if (!isMultiple && refs.length <= 1 && !isDefined(refs[0])) {
    if (isDev) {
      console.warn(
        `[${that.__base.$options.name}]`,
        `The "${refName}" ref is missing.`,
        `Is there an \`[data-ref="${refName}"]\` element in the component's scope?`
      );
    }
    return;
  }
  that.__eventsManager.bindRef(refName, refs);
  Object.defineProperty(that, propName, {
    value: isMultiple || refs.length > 1 ? refs : refs[0],
    enumerable: true,
    configurable: true
  });
}
function __unregister(that, refName) {
  const propName = normalizeRefName(refName);
  const refs = isArray(that[propName]) ? that[propName] : [that[propName]];
  that.__eventsManager.unbindRef(refName, refs);
}
class RefsManager extends AbstractManager {
  get __refs() {
    return this.__config.refs ?? [];
  }
  registerAll() {
    this.__refs.forEach((refName) => __register(this, refName));
  }
  unregisterAll() {
    this.__refs.forEach((refName) => __unregister(this, refName));
  }
}
export {
  RefsManager,
  normalizeRefName
};
//# sourceMappingURL=RefsManager.js.map
